module.exports = __webpack_public_path__ + "img/to do-no-text.eb94e812.svg";